import { render, staticRenderFns } from "./Adeletebe.vue?vue&type=template&id=62b2fdce&scoped=true"
import script from "./Adeletebe.vue?vue&type=script&lang=js"
export * from "./Adeletebe.vue?vue&type=script&lang=js"
import style0 from "./Adeletebe.vue?vue&type=style&index=0&id=62b2fdce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b2fdce",
  null
  
)

export default component.exports